module.exports = "//img1.rrcimg.com/_next/static/src/assets/sh_3Ht9U.png";